import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { Button, Card, Col, Form, OverlayTrigger, Row, Spinner, Tooltip, Alert, Badge, Modal } from 'react-bootstrap';
import useToken from 'hooks/useToken';
import { Link } from 'react-router-dom';
import { useToast } from 'context/providers/ToastProvider';
import { ContabilidadLayout } from 'akasia-components/Contabilidad/common/ContabilidadLayout';

const CargarXML = () => {

    const { token, setToken, idCatTipoUsuario } = useToken();
    const navigate = useNavigate();
    const { showErrorToast, showSuccessToast } = useToast();

    const [files, setFiles] = useState([]);
    const [uploadStatus, setUploadStatus] = useState([]);

    // Estados para descarga de metadatos
    const [showMetadataForm, setShowMetadataForm] = useState(false);
    const [metadataLoading, setMetadataLoading] = useState(false);
    const [metadataResponse, setMetadataResponse] = useState(null);
    const [metadataForm, setMetadataForm] = useState({
        rfc: '',
        tipoPeticion: 'receptor',
        fechaInicio: '',
        fechaFin: '',
        montoMinimo: '0',
        montoMaximo: '0'
    });

    // Estados para descarga masiva
    const [showDescargaMasivaForm, setShowDescargaMasivaForm] = useState(false);
    const [descargaMasivaLoading, setDescargaMasivaLoading] = useState(false);
    const [descargaMasivaResponse, setDescargaMasivaResponse] = useState(null);
    const [showModalConsultandoEstatus, setShowModalConsultandoEstatus] = useState(false);
    const [estatusResponse, setEstatusResponse] = useState(null);
    const [pfxFile, setPfxFile] = useState(null);
    const [descargaMasivaForm, setDescargaMasivaForm] = useState({
        rfcSolicitante: '',
        rfcEmisor: '',
        rfcReceptor: '',
        fechaInicio: '',
        fechaFinal: '',
        tipoSolicitud: 'CFDI',
        password: ''
    });

    const ValidarArchivos = (f) => {
        const selectedFiles = Array.from(f);
        const statusArray = selectedFiles.map((file) => ({
            nombre: file.name,
            mensaje: "",
            size: file.size,
            status: 0,
            vBillType: "",
            file: file
        }));
        setFiles(selectedFiles);
        setUploadStatus(statusArray);
    }


    //Enviar Archivos
    const onSubmitCargarArchivo = async () => {
        const updatedStatusArray = [...uploadStatus];

        try {
            for (let i = 0; i < files.length; i++) {

                var data = new FormData()
                data.append('XMLFile', files[i]);

                try {
                    const response = await fetch("/api/contabilidad/centro-xml/DescargaMasivaXML/ImportarXML", {
                        method: 'POST',
                        body: data,
                        headers:
                        {
                            'Authorization': 'Bearer ' + token
                        }
                    });

                    if (response.ok) {
                        const data = await response.json();
                        updatedStatusArray[i].status = data.iResponseType;
                        updatedStatusArray[i].mensaje = data.vMessage;
                        if (data.detalles != null) {
                            var detalles = JSON.parse(data.detalles);
                            updatedStatusArray[i].vBillType = detalles[0].vBillType;
                        }


                    } else {
                        if (response.status == 401) {
                            setToken(null);
                            location.href = "";
                        }
                        updatedStatusArray[i].status = 2;
                        showErrorToast(`Error al cargar ${files[i].name}: ${response.status} ${response.statusText}`);
                    }
                } catch (error) {
                    updatedStatusArray[i].status = 2;
                    showErrorToast(`Hubo un problema al cargar ${files[i].name}: ${error.message}`);
                }

                setUploadStatus([...updatedStatusArray]);
            }
        } catch (error) {
            showErrorToast('Error al procesar los archivos: ' + error.message);
        }
    };

    /**
     * Solicitar metadatos de XML al SAT
     */
    const onSubmitSolicitarMetadatos = async (e) => {
        e.preventDefault();
        setMetadataLoading(true);
        setMetadataResponse(null);

        try {
            // Convertir RFCs a array (separados por coma)
            const rfcArray = metadataForm.rfc.split(',').map(r => r.trim()).filter(r => r.length > 0);

            if (rfcArray.length === 0) {
                showErrorToast('Debe proporcionar al menos un RFC');
                setMetadataResponse({
                    iResponseType: 2,
                    vMessage: 'Debe proporcionar al menos un RFC'
                });
                setMetadataLoading(false);
                return;
            }

            const requestData = {
                rfc: rfcArray,
                tipoPeticion: metadataForm.tipoPeticion,
                fechaInicio: metadataForm.fechaInicio,
                fechaFin: metadataForm.fechaFin,
                montoMinimo: metadataForm.montoMinimo,
                montoMaximo: metadataForm.montoMaximo
            };

            const response = await fetch("/api/contabilidad/centro-xml/DescargaMasivaXML/SolicitarMetadatosXML", {
                method: 'POST',
                body: JSON.stringify(requestData),
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                }
            });

            if (response.ok) {
                const data = await response.json();
                setMetadataResponse(data);

                if (data.iResponseType === 1) {
                    showSuccessToast('Solicitud de metadatos enviada exitosamente');
                } else {
                    showErrorToast(data.vMessage || 'Error al solicitar metadatos');
                }
            } else {
                if (response.status === 401) {
                    setToken(null);
                    location.href = "";
                } else {
                    showErrorToast(`Error ${response.status}: Error al solicitar metadatos`);
                    setMetadataResponse({
                        iResponseType: 2,
                        vMessage: 'Error al solicitar metadatos'
                    });
                }
            }
        } catch (error) {
            showErrorToast('Hubo un problema con la petición: ' + error.message);
            setMetadataResponse({
                iResponseType: 2,
                vMessage: 'Hubo un problema con la petición: ' + error.message
            });
        } finally {
            setMetadataLoading(false);
        }
    };

    /**
     * Convierte un archivo a Base64
     */
    const convertirArchivoABase64 = (file) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => {
                // Remover el prefijo "data:application/x-pkcs12;base64,"
                const base64 = reader.result.split(',')[1];
                resolve(base64);
            };
            reader.onerror = error => reject(error);
        });
    };

    /**
     * Maneja el cambio del archivo PFX
     */
    const handlePfxFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            if (file.name.endsWith('.pfx') || file.name.endsWith('.p12')) {
                setPfxFile(file);
            } else {
                showErrorToast('Por favor seleccione un archivo .pfx o .p12 válido');
                e.target.value = null;
            }
        }
    };

    /**
     * Genera una solicitud de descarga masiva
     */
    const onSubmitGenerarDescargaMasiva = async (e) => {
        e.preventDefault();
        setDescargaMasivaLoading(true);
        setDescargaMasivaResponse(null);
        setEstatusResponse(null);

        try {
            if (!pfxFile) {
                showErrorToast('Debe seleccionar un archivo PFX');
                setDescargaMasivaLoading(false);
                return;
            }

            // Convertir PFX a Base64
            const pfxBase64 = await convertirArchivoABase64(pfxFile);

            // Enviar solo las fechas sin hora, el backend las formateará correctamente
            const requestData = {
                rfcSolicitante: descargaMasivaForm.rfcSolicitante,
                rfcEmisor: descargaMasivaForm.rfcEmisor || null,
                rfcReceptor: descargaMasivaForm.rfcReceptor || null,
                fechaInicio: descargaMasivaForm.fechaInicio,
                fechaFinal: descargaMasivaForm.fechaFinal,
                tipoSolicitud: descargaMasivaForm.tipoSolicitud,
                pfx: pfxBase64,
                password: descargaMasivaForm.password
            };

            const response = await fetch("/api/contabilidad/centro-xml/DescargaMasivaXML/GenerarSolicitudDescargaMasiva", {
                method: 'POST',
                body: JSON.stringify(requestData),
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                }
            });

            if (response.ok) {
                const data = await response.json();
                setDescargaMasivaResponse(data);

                if (data.iResponseType === 1) {
                    showSuccessToast('Solicitud de descarga masiva generada exitosamente');
                } else {
                    showErrorToast(data.vMessage || 'Error al generar solicitud de descarga masiva');
                }
            } else {
                if (response.status === 401) {
                    setToken(null);
                    location.href = "";
                } else {
                    const errorText = await response.text();
                    console.error('Error del servidor:', errorText);
                    showErrorToast(`Error ${response.status}: Error al generar solicitud de descarga masiva`);
                    setDescargaMasivaResponse({
                        iResponseType: 2,
                        vMessage: 'Error al generar solicitud de descarga masiva'
                    });
                }
            }
        } catch (error) {
            showErrorToast('Hubo un problema con la petición: ' + error.message);
            setDescargaMasivaResponse({
                iResponseType: 2,
                vMessage: 'Hubo un problema con la petición: ' + error.message
            });
        } finally {
            setDescargaMasivaLoading(false);
        }
    };

    /**
     * Consulta el estatus de una solicitud
     */
    const onConsultarEstatus = async (numeroSolicitud) => {
        setShowModalConsultandoEstatus(true);
        setEstatusResponse(null);

        try {
            const response = await fetch("/api/contabilidad/centro-xml/DescargaMasivaXML/ConsultarEstatusSolicitud", {
                method: 'POST',
                body: JSON.stringify(numeroSolicitud),
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                }
            });

            if (response.ok) {
                const data = await response.json();
                setEstatusResponse(data);

                if (data.iResponseType === 1) {
                    if (data.detalles && data.detalles.paquetesListos) {
                        showSuccessToast('Paquetes listos para descarga');
                    } else {
                        showSuccessToast('Estatus consultado exitosamente');
                    }
                } else {
                    showErrorToast(data.vMessage || 'Error al consultar estatus');
                }
            } else {
                if (response.status === 401) {
                    setToken(null);
                    location.href = "";
                } else {
                    showErrorToast(`Error ${response.status}: Error al consultar estatus`);
                    setEstatusResponse({
                        iResponseType: 2,
                        vMessage: 'Error al consultar estatus'
                    });
                }
            }
        } catch (error) {
            showErrorToast('Hubo un problema con la petición: ' + error.message);
            setEstatusResponse({
                iResponseType: 2,
                vMessage: 'Hubo un problema con la petición: ' + error.message
            });
        } finally {
            setShowModalConsultandoEstatus(false);
        }
    };

    /**
     * Obtiene el badge de estado según el código
     */
    const getEstadoBadge = (estadoSolicitud) => {
        switch (estadoSolicitud) {
            case "5000":
                return <Badge bg="success">Solicitud Aceptada</Badge>;
            case "2":
                return <Badge bg="warning">En Progreso</Badge>;
            case "7":
                return <Badge bg="success">Paquetes Listos</Badge>;
            case "800":
                return <Badge bg="danger">Error</Badge>;
            default:
                return <Badge bg="secondary">{estadoSolicitud}</Badge>;
        }
    };

    /**
    * Verifica los permisos
    */
    const checkPermisos = async () => {
        try {
            const response = await fetch("/api/Administradores/checkPermisos",
                {
                    method: 'POST',
                    headers:
                    {
                        'Authorization': 'Bearer ' + token,
                        'Content-Type': 'application/json'
                    }
                });

            if (response.ok) {
                const responseType = await response.json();

                if (responseType.iResponseType == 1) {
                    if (files.length > 0) {
                        onSubmitCargarArchivo();
                    }
                } else {
                    showErrorToast('No tiene permisos para acceder a esta sección');
                    navigate("/");
                }
            } else {
                showErrorToast('Error al verificar permisos');
                navigate("/");
            }
        } catch (error) {
            showErrorToast('Hubo un problema al verificar permisos: ' + error.message);
        }
    }

    useEffect(() => {

        if (idCatTipoUsuario != 1) {
            navigate("/");
        }

        checkPermisos();

    }, [files]);

    return (
        <ContabilidadLayout title="Descarga masiva">
            <Card className="mb-3">
                <Card.Header>
                    <Row className="align-items-center">
                        <Col>

                            <h5 className="mb-0"><img src="/img/cargarXML/xml48.png" height={48}></img> Módulo para ingresar facturas al Admin Panel</h5>
                        </Col>
                        <Col xs="auto">
                            <img src="/img/cargarXML/logoHacienda.png" height={48}></img>
                            <img src="/img/cargarXML/logoSAT.png" height={32}></img>
                        </Col>
                    </Row>
                    <hr></hr>
                </Card.Header>
                <Card.Body>
                    <Row>
                        <Col>
                            <Form.Group controlId="formFileSm" className="mb-3">
                                <Form.Label>Selecciona los archivos XML</Form.Label>
                                <Form.Control
                                    type="file"
                                    multiple
                                    size="sm"
                                    accept=".xml"
                                    onChange={(e) => ValidarArchivos(e.target.files)}
                                />
                            </Form.Group>
                        </Col>
                        <Col>

                        </Col>
                    </Row>
                    <Row>
                        <p>Archivos seleccionados:</p>
                        <Col>
                            {uploadStatus.map((fileStatus, i) => {
                                return (
                                    <Row key={i}>
                                        <Col >
                                            {
                                                fileStatus.status == 0 &&
                                                <Spinner animation="border" variant="primary" size="sm" />
                                            }
                                            {
                                                fileStatus.status == 1 &&
                                                <>
                                                    <img src="/img/check25.png" width={20}></img>
                                                    <span className="fs--1">[{fileStatus.vBillType}]&nbsp;</span>
                                                </>
                                            }
                                            {
                                                fileStatus.status == 2 &&
                                                <>
                                                    <OverlayTrigger
                                                        placement="top"
                                                        overlay={
                                                            <Tooltip style={{ position: 'fixed' }} >
                                                                <strong>{fileStatus.mensaje}</strong>
                                                            </Tooltip>
                                                        }
                                                    >
                                                        <img src="/img/cancelar30.png" width={20}></img>
                                                    </OverlayTrigger> <span className="fs--1">[{fileStatus.vBillType}]&nbsp;</span>
                                                </>
                                            }
                                            {
                                                fileStatus.status == 3 &&
                                                <>
                                                    <OverlayTrigger
                                                        placement="top"
                                                        overlay={
                                                            <Tooltip style={{ position: 'fixed' }} >
                                                                <strong>{fileStatus.mensaje}</strong>
                                                            </Tooltip>
                                                        }
                                                    >
                                                        <img src="/img/cargarXML/actualizar20.png" width={20}></img>
                                                    </OverlayTrigger> <span className="fs--1">[{fileStatus.vBillType}]&nbsp;</span>
                                                </>
                                            }
                                            <span className="fs--1"><Link to={fileStatus.file} download={fileStatus.name}> {fileStatus.nombre} ({fileStatus.size} bytes) </Link> </span>

                                        </Col>
                                    </Row>)
                            })}

                        </Col>
                    </Row>
                </Card.Body>
            </Card>

            {/* Sección para descarga masiva de XMLs */}
            <Card className="mb-3">
                <Card.Header>
                    <Row className="align-items-center">
                        <Col>
                            <h5 className="mb-0">
                                <img src="/img/cargarXML/xml48.png" height={32}></img>
                                &nbsp;Descarga Masiva de CFDIs
                            </h5>
                        </Col>
                        <Col xs="auto">
                            <Button
                                variant="info"
                                size="sm"
                                onClick={() => setShowDescargaMasivaForm(!showDescargaMasivaForm)}
                            >
                                {showDescargaMasivaForm ? 'Ocultar' : 'Mostrar'} Formulario
                            </Button>
                        </Col>
                    </Row>
                </Card.Header>
                {showDescargaMasivaForm && (
                    <Card.Body>
                        <Alert variant="info">
                            <strong>Nota:</strong> La descarga masiva permite obtener los CFDIs directamente del SAT.
                            Debe proporcionar su archivo FIEL (.pfx) y al menos un RFC (emisor o receptor) que coincida con el RFC solicitante.
                        </Alert>

                        <Form onSubmit={onSubmitGenerarDescargaMasiva}>
                            <Row>
                                <Col md={6}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>RFC Solicitante <span className="text-danger">*</span></Form.Label>
                                        <Form.Control
                                            type="text"
                                            placeholder="RFC del solicitante"
                                            value={descargaMasivaForm.rfcSolicitante}
                                            onChange={(e) => setDescargaMasivaForm({ ...descargaMasivaForm, rfcSolicitante: e.target.value.toUpperCase() })}
                                            required
                                            disabled={descargaMasivaLoading}
                                            maxLength={13}
                                        />
                                        <Form.Text className="text-muted">
                                            RFC correspondiente al archivo PFX
                                        </Form.Text>
                                    </Form.Group>
                                </Col>
                                <Col md={6}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Tipo de Solicitud <span className="text-danger">*</span></Form.Label>
                                        <Form.Select
                                            value={descargaMasivaForm.tipoSolicitud}
                                            onChange={(e) => setDescargaMasivaForm({ ...descargaMasivaForm, tipoSolicitud: e.target.value })}
                                            disabled={descargaMasivaLoading}
                                        >
                                            <option value="CFDI">CFDI - Descargar comprobantes XML</option>
                                            <option value="Metadata">Metadata - Descargar archivo de metadatos</option>
                                        </Form.Select>
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={6}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>RFC Emisor</Form.Label>
                                        <Form.Control
                                            type="text"
                                            placeholder="RFC del emisor (opcional)"
                                            value={descargaMasivaForm.rfcEmisor}
                                            onChange={(e) => setDescargaMasivaForm({ ...descargaMasivaForm, rfcEmisor: e.target.value.toUpperCase() })}
                                            disabled={descargaMasivaLoading}
                                            maxLength={13}
                                        />
                                    </Form.Group>
                                </Col>
                                <Col md={6}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>RFC Receptor</Form.Label>
                                        <Form.Control
                                            type="text"
                                            placeholder="RFC del receptor (opcional)"
                                            value={descargaMasivaForm.rfcReceptor}
                                            onChange={(e) => setDescargaMasivaForm({ ...descargaMasivaForm, rfcReceptor: e.target.value.toUpperCase() })}
                                            disabled={descargaMasivaLoading}
                                            maxLength={13}
                                        />
                                        <Form.Text className="text-muted">
                                            Al menos uno (Emisor o Receptor) debe coincidir con el RFC Solicitante
                                        </Form.Text>
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={6}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Fecha Inicio <span className="text-danger">*</span></Form.Label>
                                        <Form.Control
                                            type="date"
                                            value={descargaMasivaForm.fechaInicio}
                                            onChange={(e) => setDescargaMasivaForm({ ...descargaMasivaForm, fechaInicio: e.target.value })}
                                            required
                                            disabled={descargaMasivaLoading}
                                        />
                                    </Form.Group>
                                </Col>
                                <Col md={6}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Fecha Final <span className="text-danger">*</span></Form.Label>
                                        <Form.Control
                                            type="date"
                                            value={descargaMasivaForm.fechaFinal}
                                            onChange={(e) => setDescargaMasivaForm({ ...descargaMasivaForm, fechaFinal: e.target.value })}
                                            required
                                            disabled={descargaMasivaLoading}
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={6}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Archivo FIEL (PFX) <span className="text-danger">*</span></Form.Label>
                                        <Form.Control
                                            type="file"
                                            accept=".pfx,.p12"
                                            onChange={handlePfxFileChange}
                                            required
                                            disabled={descargaMasivaLoading}
                                        />
                                        <Form.Text className="text-muted">
                                            Archivo .pfx o .p12 de su FIEL
                                        </Form.Text>
                                    </Form.Group>
                                </Col>
                                <Col md={6}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Contraseña FIEL <span className="text-danger">*</span></Form.Label>
                                        <Form.Control
                                            type="password"
                                            placeholder="Contraseña de su FIEL"
                                            value={descargaMasivaForm.password}
                                            onChange={(e) => setDescargaMasivaForm({ ...descargaMasivaForm, password: e.target.value })}
                                            required
                                            disabled={descargaMasivaLoading}
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <Button
                                        type="submit"
                                        variant="success"
                                        disabled={descargaMasivaLoading}
                                    >
                                        {descargaMasivaLoading ? (
                                            <>
                                                <Spinner
                                                    as="span"
                                                    animation="border"
                                                    size="sm"
                                                    role="status"
                                                    aria-hidden="true"
                                                    className="me-2"
                                                />
                                                Generando Solicitud...
                                            </>
                                        ) : (
                                            'Generar Solicitud de Descarga'
                                        )}
                                    </Button>
                                </Col>
                            </Row>
                        </Form>

                        {descargaMasivaResponse && (
                            <Row className="mt-3">
                                <Col>
                                    <Alert variant={descargaMasivaResponse.iResponseType === 1 ? 'success' : 'danger'}>
                                        <Alert.Heading>
                                            {descargaMasivaResponse.iResponseType === 1 ? 'Éxito' : 'Error'}
                                        </Alert.Heading>
                                        <p>{descargaMasivaResponse.vMessage}</p>
                                        {descargaMasivaResponse.detalles && descargaMasivaResponse.detalles.numeroSolicitud && (
                                            <div>
                                                <hr />
                                                <p className="mb-2">
                                                    <strong>Número de Solicitud:</strong> {descargaMasivaResponse.detalles.numeroSolicitud}
                                                </p>
                                                <p className="mb-2">
                                                    <strong>Estado:</strong> {getEstadoBadge(descargaMasivaResponse.detalles.estadoSolicitud)}
                                                </p>
                                                {descargaMasivaResponse.detalles.respuestaSAT && (
                                                    <p className="mb-2">
                                                        <strong>SAT:</strong> {descargaMasivaResponse.detalles.respuestaSAT.mensaje}
                                                    </p>
                                                )}
                                                <Button
                                                    variant="primary"
                                                    size="sm"
                                                    onClick={() => onConsultarEstatus(descargaMasivaResponse.detalles.numeroSolicitud)}
                                                    className="mt-2"
                                                >
                                                    Consultar Estatus
                                                </Button>
                                            </div>
                                        )}
                                    </Alert>
                                </Col>
                            </Row>
                        )}

                        {estatusResponse && (
                            <Row className="mt-3">
                                <Col>
                                    <Alert variant={estatusResponse.iResponseType === 1 ? 'info' : 'danger'}>
                                        <Alert.Heading>Estatus de la Solicitud</Alert.Heading>
                                        <p>{estatusResponse.vMessage}</p>
                                        {estatusResponse.detalles && (
                                            <div>
                                                <hr />
                                                <p className="mb-2">
                                                    <strong>Estado:</strong> {getEstadoBadge(estatusResponse.detalles.estadoSolicitud)}
                                                </p>
                                                {estatusResponse.detalles.paquetesListos && estatusResponse.detalles.paquetes && (
                                                    <div>
                                                        <p className="mb-2"><strong>Paquetes disponibles para descarga:</strong></p>
                                                        <ul>
                                                            {estatusResponse.detalles.paquetes.map((url, idx) => (
                                                                <li key={idx}>
                                                                    <a href={url} target="_blank" rel="noopener noreferrer" className="text-break">
                                                                        Descargar Paquete {idx + 1}
                                                                    </a>
                                                                    <br />
                                                                    <small className="text-muted">
                                                                        (Disponible por 5 minutos)
                                                                    </small>
                                                                </li>
                                                            ))}
                                                        </ul>
                                                    </div>
                                                )}
                                                {!estatusResponse.detalles.paquetesListos && (
                                                    <p className="text-muted mb-0">
                                                        Los paquetes aún no están listos. Por favor, consulte nuevamente en unos minutos.
                                                    </p>
                                                )}
                                            </div>
                                        )}
                                    </Alert>
                                </Col>
                            </Row>
                        )}
                    </Card.Body>
                )}
            </Card>

            {/* Nueva sección para descargar metadatos del SAT */}
            <Card className="mb-3">
                <Card.Header>
                    <Row className="align-items-center">
                        <Col>
                            <h5 className="mb-0">
                                <img src="/img/cargarXML/xml48.png" height={32}></img>
                                &nbsp;Descargar Metadatos de XMLs del SAT
                            </h5>
                        </Col>
                        <Col xs="auto">
                            <Button
                                variant="primary"
                                size="sm"
                                onClick={() => setShowMetadataForm(!showMetadataForm)}
                            >
                                {showMetadataForm ? 'Ocultar' : 'Mostrar'} Formulario
                            </Button>
                        </Col>
                    </Row>
                </Card.Header>
                {showMetadataForm && (
                    <Card.Body>
                        <Form onSubmit={onSubmitSolicitarMetadatos}>
                            <Row>
                                <Col md={6}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>RFC(s) <span className="text-danger">*</span></Form.Label>
                                        <Form.Control
                                            type="text"
                                            placeholder="RFC1, RFC2, RFC3..."
                                            value={metadataForm.rfc}
                                            onChange={(e) => setMetadataForm({ ...metadataForm, rfc: e.target.value })}
                                            required
                                            disabled={metadataLoading}
                                        />
                                        <Form.Text className="text-muted">
                                            Ingrese uno o más RFCs separados por comas
                                        </Form.Text>
                                    </Form.Group>
                                </Col>
                                <Col md={6}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Tipo de Petición <span className="text-danger">*</span></Form.Label>
                                        <Form.Select
                                            value={metadataForm.tipoPeticion}
                                            onChange={(e) => setMetadataForm({ ...metadataForm, tipoPeticion: e.target.value })}
                                            disabled={metadataLoading}
                                        >
                                            <option value="emisor">Emisor</option>
                                            <option value="receptor">Receptor</option>
                                        </Form.Select>
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={6}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Fecha Inicio <span className="text-danger">*</span></Form.Label>
                                        <Form.Control
                                            type="date"
                                            value={metadataForm.fechaInicio}
                                            onChange={(e) => setMetadataForm({ ...metadataForm, fechaInicio: e.target.value })}
                                            required
                                            disabled={metadataLoading}
                                        />
                                    </Form.Group>
                                </Col>
                                <Col md={6}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Fecha Fin <span className="text-danger">*</span></Form.Label>
                                        <Form.Control
                                            type="date"
                                            value={metadataForm.fechaFin}
                                            onChange={(e) => setMetadataForm({ ...metadataForm, fechaFin: e.target.value })}
                                            required
                                            disabled={metadataLoading}
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={6}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Monto Mínimo</Form.Label>
                                        <Form.Control
                                            type="number"
                                            step="0.01"
                                            min="0"
                                            value={metadataForm.montoMinimo}
                                            onChange={(e) => setMetadataForm({ ...metadataForm, montoMinimo: e.target.value })}
                                            disabled={metadataLoading}
                                        />
                                    </Form.Group>
                                </Col>
                                <Col md={6}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Monto Máximo</Form.Label>
                                        <Form.Control
                                            type="number"
                                            step="0.01"
                                            min="0"
                                            value={metadataForm.montoMaximo}
                                            onChange={(e) => setMetadataForm({ ...metadataForm, montoMaximo: e.target.value })}
                                            disabled={metadataLoading}
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <Button
                                        type="submit"
                                        variant="success"
                                        disabled={metadataLoading}
                                    >
                                        {metadataLoading ? (
                                            <>
                                                <Spinner
                                                    as="span"
                                                    animation="border"
                                                    size="sm"
                                                    role="status"
                                                    aria-hidden="true"
                                                    className="me-2"
                                                />
                                                Solicitando...
                                            </>
                                        ) : (
                                            'Solicitar Metadatos'
                                        )}
                                    </Button>
                                </Col>
                            </Row>
                        </Form>

                        {metadataResponse && (
                            <Row className="mt-3">
                                <Col>
                                    <Alert variant={metadataResponse.iResponseType === 1 ? 'success' : 'danger'}>
                                        <Alert.Heading>
                                            {metadataResponse.iResponseType === 1 ? 'Éxito' : 'Error'}
                                        </Alert.Heading>
                                        <p>{metadataResponse.vMessage}</p>
                                        {metadataResponse.detalles && metadataResponse.detalles.solicitudId && (
                                            <div>
                                                <hr />
                                                <p className="mb-0">
                                                    <strong>ID de Solicitud:</strong> {metadataResponse.detalles.solicitudId}
                                                </p>
                                                <p className="mb-0 text-muted">
                                                    La solicitud ha sido guardada. Los metadatos se procesarán y estarán disponibles próximamente.
                                                </p>
                                            </div>
                                        )}
                                    </Alert>
                                </Col>
                            </Row>
                        )}
                    </Card.Body>
                )}
            </Card>

            {/* Modal de Carga para Consulta de Estatus */}
            <Modal
                show={showModalConsultandoEstatus}
                backdrop="static"
                keyboard={false}
                centered
                size="sm"
            >
                <Modal.Body className="text-center py-4">
                    <Spinner animation="border" variant="primary" className="mb-3" />
                    <h5 className="mb-2">Consultando estatus de la solicitud</h5>
                    <p className="text-muted mb-0">Por favor espere...</p>
                </Modal.Body>
            </Modal>

        </ContabilidadLayout>
    );
}

export default CargarXML;